import React from 'react'
import { Switch, Route, Link} from 'react-router-dom';
import { Layout, Typography, Space} from 'antd';
import './App.css';

import Navbar from './components/Navbar';
import Homepage from './components/Homepage';
import Cryptocurrencies from './components/Cryptocurrencies';
import CryptoDetails from './components/CryptoDetails';
import Exchanges from './components/Exchanges';
import News from './components/News';

const { Title } = Typography;

const App = () => {
    return (
        <div className="app">
            
            <div className="navbar">
                <Navbar/>
            </div>
            
            <div className="main">

                <Layout>
                    <div className="routes">
                        <Switch>
                            <Route exact path="/">
                                <Homepage />
                            </Route>
                            <Route exact path="/exchanges">
                                <Exchanges />
                            </Route>
                            <Route exact path="/cryptocurrencies">
                                <Cryptocurrencies />
                            </Route>
                            <Route exact path="/cryptodetails/:coinId">
                                <CryptoDetails/>
                            </Route>
                            <Route exact path="/news">
                                <News />
                            </Route>
                        </Switch>
                    </div>
                </Layout>

                <div className="footer" >
                    <Title level={5} style={{color:'white', textAlign: 'center'}}>
                        <Link to="/">
                            CryptoChain <br />
                            All rights reserved
                        </Link>
                    </Title>
                    <Space>
                        <Link to="/">Home</Link>
                        <Link to="/exchanges">Exchanges</Link>
                        <Link to="/news">News</Link>
                    </Space>
                </div>

            </div>

        </div> 
    )
}

export default App;
